import { HostListener, Component, OnInit, EventEmitter, Input, Output, ViewChild, OnChanges, Inject, SimpleChanges } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { AuthenticationComponent } from '../../components/authentication/authentication.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { GlobalConstants } from '../../services/global-variables';
import { Location, DOCUMENT } from '@angular/common';
import { AubTrackingService } from '../../services/aub-tracking.service';
import { Subscription } from 'rxjs';

declare global {
  interface Window { dataLayer: any[]; smartech: any }
}
// import { BsModalService } from 'ngx-bootstrap/modal';
// import { SearchComponent } from './search-modal/search-modal.component';
// import { AddCardModalComponent } from 'src/app/components/addCard-modal/addCard-modal.component';
import { DataTransferService } from '../../services/datatransfer.service';
import { AubGTMTrackingService } from 'src/app/services/aub-gtm-tracking.service';
import { BrowserStorageService } from 'src/app/services/browser-storage.service';
import { ModalWrapperService } from 'src/app/ui-components/modal-wrapper/modal-wrapper.service';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
  providers: [ApiService, GlobalConstants]
})
export class HeaderComponent implements OnInit, OnChanges {
  @Output() reloadTemplate = new EventEmitter();
  @Input() refreshHeader: boolean = false;
  @Input() milestoneRewardsExists: boolean = false;
  @Input() selectedCategory = '';
  // @ViewChild(AuthenticationComponent) authC: AuthenticationComponent = '';
  modalRef: any;
  isloading = true;
  IDLE_TIMEOUT = 900;
  _idleSecondsTimer = null;
  _idleSecondsCounter = 0;
  // showAuthentication: any = false;

  modalInstance:any;




  deviceInfo = null;
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  isLoggedIn: boolean = false;
  modalOpen: any = false;
  openMenu: any = false;
  openMenuMob: any = false;
  modalOpenMob: any = false;
  userCards: any = [];
  urlcode: any;
  currentUserCard: any;

  activeCardType: any;
  activeTab: 'deals' | 'milestone' = 'deals';
  showHeaderLinks = false;
  nocardUser = false;
  hideLogout = false;
  customer_type: any;
  appUser = false;
  private reloadSubScription: Subscription = {} as Subscription;

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth > 1024) {
      this.isDesktopDevice = true;
      this.isTablet = false;
      this.isMobile = false;
    }
    else if (window.innerWidth > 768) {
      this.isDesktopDevice = false;
      this.isTablet = true;
      this.isMobile = false;
    }
    else {
      this.isDesktopDevice = false;
      this.isTablet = false;
      this.isMobile = true;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event): void {
    // Trigger logout function when user navigates away from the application
    if (this.browserStore.get("currentUser") && !this.browserStore.get("skipReloadLogout", 'session') && !this.browserStore.get("appUser")) {
      this.authenticationService.logout();
    }
    
  }

  ngOnDestroy() {
    if (this.reloadSubScription) {
      this.reloadSubScription.unsubscribe();
    }
  }
  constructor(
    private router: Router,
    private _aubts: AubTrackingService,
    private _aubgtm: AubGTMTrackingService,
    public _apiService: ApiService,
    private authenticationService: AuthenticationService,
    public GlobalConstants: GlobalConstants,
    private location: Location,
    private route: ActivatedRoute,
    // private modalService: BsModalService,
    @Inject(DOCUMENT) private document: any,
    private browserStore : BrowserStorageService,
    public dataTransferService: DataTransferService,
    private modalService : ModalWrapperService,
  ) {
    this.reloadSubScription = this.dataTransferService.sharedReloadHeaderEvent.subscribe((resp: any) => {
      if (resp) {
        this.ngOnInit()
      }
    });
  }

  getCards(): Promise<any> {
    return new Promise((resolve,reject)=>{
      this._apiService.getCards().subscribe(
        (res: any) => {
          this.userCards = res.data;

          this.browserStore.set("userCards", JSON.stringify(this.userCards));
          this.userCards.forEach((x: any) => {
            if (this.currentUserCard != 'undefined' && this.currentUserCard && this.currentUserCard.id && (x.id == this.currentUserCard.id)) {
              x['currentCard'] = true;
            } else {
              x['currentCard'] = false;
            }
          });
          resolve('success');
        },
        (err) => {
          resolve('failure');
        }
      );
    })

  }

  ngOnInit() {
    this.onResize();
    this.route.queryParams.subscribe(params => {
      this.urlcode = params.code;
    });
    this.getSharedCountries();
    if (JSON.parse(this.browserStore.get('card_verified')) == false) {
      localStorage.removeItem('currentUser');
    }
    if (this.browserStore.get('selectedCardType')) {
      this.activeCardType = this.browserStore.get('selectedCardType')
    }
    if (this.browserStore.get("currentUser")) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }

    if (this.browserStore.get("has_special_bundles")) {
      if (this.browserStore.get("has_special_bundles") == 'true') {
        this.milestoneRewardsExists = true;
      } else {
        this.milestoneRewardsExists = false;
      }
    }


    if (this.isLoggedIn) {
      this.getCards();
    }

    if (this.browserStore.get('userCard') && this.browserStore.get('userCard') != 'undefined') {
      let usercard = JSON.parse(this.browserStore.get('userCard'));
      this.currentUserCard = usercard;
    }

    this.showHeaderLinks = true;

    if (this.browserStore.get("customer_type") && this.browserStore.get("urlcode")) {
      this.customer_type = this.browserStore.get("customer_type");
      if (this.browserStore.get("customer_type") == 'ntb' || this.browserStore.get("customer_type") == 'noetb') {
        this.nocardUser = true;
      }

    }
    if (this.browserStore.get("channel_ref") && this.browserStore.get("channel_ref") == 'mb') {
      this.hideLogout = true;
      this.appUser = true;
    }
    if (this.browserStore.get("appUser") && this.browserStore.get("appUser") == 'true') {
      this.appUser = true;
    }
    this.isloading = false;
    this.clearSkipReloadLogout();

  }


  private clearSkipReloadLogout(): void{
    if (this.browserStore.get("skipReloadLogout", "session")) {
      setTimeout(() => {
        this.browserStore.remove("skipReloadLogout", "session");
      }, 100);
    }
  }
  reloadInit() {
    this.ngOnInit();
    this.reloadTemplate.emit();
  }

  ngDoCheck() {
    if (this.browserStore.get("currentUser")) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }

  backClicked() {
    this.location.back();
  }

  gtmLogin() {
    this._aubgtm.pushToDataLayer({
      'event': 'offers_Login',
      'EventCategory': 'Offers Login',
      'EventAction': 'Login Click',
      'EventLabel': '',
      'url': "/vpv/offers/login"
    });
  }

  login() {
    this.gtmLogin();
    // this.authC.restartLogin();
    this.modalInstance = this.modalService.open(AuthenticationComponent,'login-modal',true);
    this.modalInstance.componentInstance.restartLogin();
    this.modalInstance.componentInstance.reloadHeader.subscribe((res:any)=>{
      // window.location.href = '/';
      this.dataTransferService.nextReloadEvent(true);
    })
    this.modalInstance.componentInstance.closeAuthenticationEvent.subscribe((res:any)=>{
      if(res){
        this.getCards().then((res)=>{
          // location.reload();
        });
        this.modalInstance.close();

      }
    })
  }

  gtmLogout() {
    let current_user = JSON.parse(this.browserStore.get("currentUser"));
    this._aubgtm.pushToDataLayer({
      'event': 'Log-out',
      'UserID': current_user.id,   //Unique Login id to be passed
      'usertype': 'Existing user' //Pass New/Existing user
    })
  }

  logout() {
    this.gtmLogout();
    this.authenticationService.deleteToken().subscribe((res) => {
      const customer_type = this.browserStore.get('customer_type');
      if (customer_type && customer_type == 'etb') {
        const returnUrl = this.browserStore.get("returnUrl");
        localStorage.clear();
        this.authenticationService.logout();
        this.browserStore.set("returnUrl", returnUrl);
        this.browserStore.set("customer_type", 'ntb-logout');
        this.browserStore.set("urlcode", 'no-token');
        this.reloadInit();
      }
      else {
        this.authenticationService.logout();
        window.location.href = "/";
      }
    }, (error) => {
      this.authenticationService.logout();
      this.router.navigate(['/']);
      window.location.href = "/";
    });
  }


  headerTimeout: any;
  ngOnChanges(change: SimpleChanges) {
    this.modalOpen = false;

    console.log(change)
    if (change.refreshHeader && change.refreshHeader.currentValue) {
      this.ngOnInit();
    }

    if (change.selectedCategory && change.selectedCategory.currentValue) {
      if (this.selectedCategory === 'exclusive-rewards') {
        this.activeTab = 'milestone';
      } else {
        this.activeTab = 'deals';
      }
    }
  }


  validateCard(card: any) {
    this._apiService.switchCard(card.id).subscribe(res => {
      if (res && res.data && res.data.attributes.bin == card.attributes.bin && res.data.attributes.status == 'bin_verified') {
        let current_user = JSON.parse(this.browserStore.get("currentUser"));
        current_user.token = res.data.attributes.session_token;
        if (current_user.skipExceptCard) {
          current_user.skipExceptCard = false;
        }
        this.browserStore.set('currentUser', JSON.stringify(current_user));
        this.browserStore.set('card_verified', "true");
        this.browserStore.set('userCard', JSON.stringify(res.data));
        // location.reload();
        this.browserStore.set('skipReloadLogout', 'true', 'session');
        location.href = '';
      }
      else {
        this.browserStore.set('card_verified', "false");
      }
    })
  }

  openSearchModal() {
    const initialState = {
      features: ['All Offers', 'Offers Near Me']
    }
    let config = {
      backdrop: true,
      ignoreBackdropClick: false
    };
    // this.modalRef = this.modalService.show(SearchComponent, Object.assign({}, config, { initialState }));
    this.modalRef.content.searchItemEvent.subscribe((res: any) => {
      if (res) {
        if (res.searchType === 'All Offers') {
          this.getMerchants(res.name);
        } else {
          this.getNearByMerchants(res.name);
        }
      }
    })
    this.modalRef.content.selectedItemEvent.subscribe((res: any) => {
      if (res) {
        this.modalRef.hide();
        const merchant = res.item;
        this.gtmSearchBar(merchant.name);
        if (merchant.searchType === 'All Offers') {
          this.router.navigate(['/offers/offer-details/' + merchant.id + '/all/' + (merchant.name ? merchant.name.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase().trim() : '')]);
        }
        else if (merchant.searchType === 'International') {
          this.router.navigate(['/offers/offer-details/' + merchant.id + '/international/' + (merchant.name ? merchant.name.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase().trim() : '')]);
        } else {
          this.router.navigate(['/offers/offer-details/' + merchant.id + '/nearby/' + (merchant.name ? merchant.name.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase().trim() : '')]);
        }
      }
    })
    this.modalRef.content.hideEvent.subscribe((res: any) => {
      if (res) { this.modalRef.hide(); }
    })
  }
  gtmSearchBar(searchText: string) {
    this._aubgtm.pushToDataLayer({
      'event': 'offers_searchbar',
      'EventCategory': 'Search for Offer',
      'EventAction': searchText
    });
    this._aubts.aubts_offers_search(searchText);
  }
  getMerchants(name: any) {
    const params = { name };
    this._apiService.searchMerchants(params).subscribe(
      (res: any) => {
        let itemArr: any[] = [];
        if (res && res.data) {
          res.data.merchants.forEach((obj: any[]) => {
            let item = {
              id: obj[0],
              name: obj[1],
              searchType: 'All Offers'
            }
            itemArr.push(item)
          });
          res.data.nearby_merchants.forEach((obj: any[]) => {
            let item = {
              id: obj[0],
              name: obj[1],
              searchType: 'Offers Near Me'
            }
            itemArr.push(item)
          });
          res.data.international_merchants.forEach((obj: any[]) => {
            let item = {
              id: obj[0],
              name: obj[1],
              searchType: 'International'
            }
            itemArr.push(item)
          });
          this.modalRef.content.itemList = itemArr.slice(0, 7);
        } else {
          this.modalRef.content.itemList = [];
        }
      },
      (err) => {
        console.log(err);
        this.modalRef.content.itemList = [];
      }
    );
  }

  getNearByMerchants(name: any) {
    const params = { name };
    this._apiService.getNearByMerchants(params).subscribe(
      (res: any) => {
        if (res && res.data) {
          this.modalRef.content.itemList = res.data.slice(0, 7);
        } else {
          this.modalRef.content.itemList = [];
        }
      },
      (err: any) => {
        console.log(err);
        this.modalRef.content.itemList = [];
      }
    );
  }
  changeCardType(cardType: string) {
    this.browserStore.set('selectedCardType', cardType);
    this.router.navigate([cardType]);
  }

  changeTab(tab: string) {
    if (this.isLoggedIn) {
      const category = this.browserStore.get("firstOfferCategory");
      if (tab == 'deals') {
        if (category) {
          this.router.navigate(['offers', category]);
        } else {
          this.router.navigate(['offers', 'nearby']);
        }
      } else {
        this.router.navigate(['offers', 'exclusive-rewards']);
      }
    } else if (tab == 'milestone') {
      this.login();
    }
  }
  openAddcardModal() {
    let config = {
      backdrop: true,
      ignoreBackdropClick: false
    };
    // this.modalRef = this.modalService.show(AddCardModalComponent, Object.assign({}, config, {}));
    this.modalRef.content.hideEvent.subscribe((res: any) => {
      if (res) { this.modalRef.hide(); }
    })
  }

  allCountries: any;
  userLocation: any;
  popularCountries: any;
  otherCountries: any;
  featuredCountryCodes = ['IND', 'SGP', 'ARE', 'AUS', 'USA', 'GBR', 'CAN', 'SAU', 'KWT', 'QAT', 'BHR', 'OMN', 'HKG', 'NZL', 'BGD'];
  getSharedCountries() {
    if (this.allCountries && this.allCountries.length > 0) {
      this.getGeoLocation();
    }
    else {
      this.getAllCountries()
    }
  }
  getAllCountries() {
    this._apiService.getAllCountries().subscribe((res: any) => {
      this.allCountries = this.processCountries(res.data);

      this.dataTransferService.nextCountries(this.allCountries)
      if (this.browserStore.get("userLocation")) {
        this.userLocation = JSON.parse(this.browserStore.get("userLocation"));
        this.dataTransferService.nextUserLocation(this.userLocation)
      }
      else {
        this.getGeoLocation();
      }
    });
  }
  processCountries(allCountries: any) {
    this.popularCountries = [];
    this.otherCountries = [];
    this.allCountries = allCountries;
    this.allCountries.sort(function (a: { attributes: { name: string; }; }, b: { attributes: { name: string; }; }) {
      let textA = a.attributes.name.toUpperCase();
      let textB = b.attributes.name.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    if (this.allCountries && this.allCountries.length > 0) {
      this.allCountries.forEach((obj: { attributes: { mobile_length: string; min_mobile_digit: number; max_mobile_digit: number; iso_code: string; }; }) => {
        let mobile_length = obj.attributes.mobile_length.split('...');
        obj.attributes.min_mobile_digit = parseInt(mobile_length[0]);
        obj.attributes.max_mobile_digit = parseInt(mobile_length[1]);
        if (this.featuredCountryCodes.includes(obj.attributes.iso_code)) {
          this.popularCountries.push(obj);
        } else {
          this.otherCountries.push(obj);
        }
      })

      // sort popular countries array w.r.t featured array
      this.popularCountries.sort((a: { attributes: { iso_code: string; }; }, b: { attributes: { iso_code: string; }; }) =>
        this.featuredCountryCodes.indexOf(a.attributes.iso_code) - this.featuredCountryCodes.indexOf(b.attributes.iso_code)

      );

      // alphabetically sort other countries
      this.otherCountries.sort(function (a: { attributes: { name: string; }; }, b: { attributes: { name: string; }; }) {
        let textA = a.attributes.name.toUpperCase();
        let textB = b.attributes.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
      this.allCountries = this.popularCountries.concat(this.otherCountries);
      return this.allCountries;
    }
  }
  getGeoLocation() {
    if (this.browserStore.get('userLocation')) {
      this.userLocation = JSON.parse(this.browserStore.get('userLocation'));
    }
    else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.userLocation = position.coords;
        let userCoordinates = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          state: null,
          county: null
        }
        this.checkCordinates(userCoordinates);
      }, () => {
        this.getIpStackLocation()
      });
    }
    else {
      this.getIpStackLocation()
    }
  }
  getIpStackLocation() {
    this._apiService.getIpStackLocation().subscribe((res: any) => {
      if (res && res.latitude && res.longitude) {
        this.userLocation = {
          latitude: res.latitude,
          longitude: res.longitude
        };
        // this.browserStore.set("userLocation", JSON.stringify({ latitude: res.latitude, longitude: res.longitude }));
        let locObj = {
          state: res.region_name.toLowerCase(),
          county: res.city.toLowerCase(),
          country: res.country_name.toLowerCase(),
          latitude: res.latitude,
          longitude: res.longitude
        }
        this.processLocation(locObj)
      }
    });
  }
  checkCordinates(param: { [x: string]: any; latitude: any; longitude: any; state?: null; county?: null; }) {
    this._apiService.checkCordinates(param.latitude + ',' + param.longitude).subscribe(
      (res: any) => {
        if (res && res.results[0] && res.results[0].components) {
          param['country'] = res.results[0].components.country.toLowerCase();
          if (res.results[0].components.county) {
            param['county'] = res.results[0].components.county.toLowerCase();
          }
          else if (res.results[0].components.city) {
            param['county'] = res.results[0].components.city.toLowerCase();
          }
          if (res.results[0].components.state) {
            param['state'] = res.results[0].components.state.toLowerCase();
          }
          this.processLocation(param);
        }
      },
      () => {
        // this.showLocationModal();
      }
    );
  }
  processLocation(data: any) {
    let userCountry = this.allCountries.find((x: { attributes: { name: string; }; }) => { return x.attributes.name.toLowerCase() == data.country })
    if (userCountry) {
      this.userLocation = data;
      this.userLocation['country'] = userCountry.attributes
      // this.browserStore.set("userLocation", JSON.stringify(this.userLocation));
      this.userLocation['refresh'] = true;
      this._apiService.getAllCities({ country_id: this.userLocation.country.id }).subscribe((res: any) => {
        if (res && res.data && res.data.length > 0) {
          let userState = res.data.filter((item: { attributes: { name: string; }; }) => {
            return item.attributes.name.toLowerCase() == this.userLocation.state
          });
          if (userState && userState.length > 0) {
            this.userLocation.state = userState[0].attributes;
          }
          this.browserStore.set("userLocation", JSON.stringify(this.userLocation));
          this.dataTransferService.nextUserLocation(this.userLocation);
        }
        else {
          this.browserStore.set("userLocation", JSON.stringify(this.userLocation));
          this.dataTransferService.nextUserLocation(this.userLocation);
        }
      });
    }
    else {
      console.log('location process error')
      // this.showLocationModal();
    }
  }
}
